import { ApiClient } from "@/apis/AxiosClient";

class ParentApi {
    constructor() {
        this.client = new ApiClient("/parent");
        this.apiClient = new ApiClient("/parents");
    }

    login(email, password) {
        return this.client.post("login", {
            email,
            password
        });
    }

    deactivate(password) {
        return this.client.post("deactivate", {
            password
        });
    }

    register(
        first_name,
        last_name,
        email,
        password,
        password_confirmation,
        terms
    ) {
        return this.client.post("register", {
            first_name,
            last_name,
            email,
            password,
            password_confirmation,
            terms
        });
    }

    forgotPassword(email) {
        return this.client.post("forgot-password", {
            email
        });
    }

    resetPassword(data) {
        return this.client.post("reset-password", data);
    }

    logout() {
        return this.client.get("logout");
    }

    children() {
        return this.client.get("children");
    }

    linkChild(name, code) {
        return this.client.put("children", {
            name,
            code
        });
    }

    selectChild(user) {
        return this.client.put("children/selected", {
            child: user.id
        });
    }

    updateParent(data) {
        return this.client.put("settings", data);
    }

    updateSettings(id, data) {
        return this.apiClient.put(`${id}/settings`, data);
    }

    getToolAccessUrl(childUserId, serviceId) {
        return this.client.get(`tool/${childUserId}/${serviceId}`);
    }

    resendVerificationEmail() {
        return this.client.post("verify");
    }

    acceptApplicationAccess() {
        //set to any non-null value temporarily. The page reload will contain actual value
        return this.client.post("applicationaccess");
    }

    getchildStats(childUserId) {
        return this.client.get(`children/${childUserId}/stats`);
    }

    getNotifications() {
        return this.client.get(`notifications`);
    }
}

export default new ParentApi();
